import axios from "axios";
import { visitSource } from "./source";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;
const SALES = process.env.REACT_APP_WHATSAPP_SALES;
const SUPPORT = process.env.REACT_APP_WHATSAPP_SUPPORT;

export const BRAND = { agent: "Bia" };

export const waLink = (kind, name) => {
  const phone = kind === "support" ? SUPPORT : SALES;
  const text = kind === "support"
    ? `Olá! Já sou assinante do ${name} e preciso de suporte.`
    : `Olá! Quero assinar o ${name} por R$ 25,00 mensais.`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
};

const sessionId = () => {
  try {
    let id = localStorage.getItem("lz_session");
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2);
      localStorage.setItem("lz_session", id);
    }
    return id;
  } catch {
    return "anon";
  }
};

export const logAction = (action) => {
  if (!API) return;
  axios
    .post(`${API}/leads/action`, { action, session_id: sessionId(), user_agent: navigator.userAgent.slice(0, 400), ...visitSource() })
    .catch(() => {});
};

export const buildScript = (name, fan = "torcedor", intro) => [
  { type: "text", text: intro || `Olá, ${fan}! Aqui é a Bia, do atendimento do ${name}.` },
  { type: "text", text: "Separei um vídeo rapidinho pra você entender como funciona:" },
  { type: "video" },
  { type: "price" },
  { type: "text", text: "Como você quer seguir? Escolha uma opção aqui embaixo." },
];

export const nowTime = () =>
  new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
